export default "__VITE_ASSET__DonQZw2c__"